import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Modal, Button, Badge, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { VerticalForm, FormInput } from '../../../../components';
import Table from '../../../../components/Table';
import {
    addZoneAPI,
    getAllVendorsAPI,
    getAllZonesAPI,
    editZoneAPI,
    deleteZoneAPI,
    getAllZonesPageAPI,
} from '../../../../API/RDPMS_API';
import moment from 'moment';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { Loading } from 'react-loading-ui';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthActionTypes } from '../../../../redux/auth/constants';
import { authApiResponseSuccess, updateUserAfterStationAdd } from '../../../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import '../../../../../src/assets/scss/custom/components/_addstation.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import { useForm } from 'react-hook-form';
import * as bootstrap from 'bootstrap';
import { addZoneColumns, sizePerPageList } from '../../../../utils/ColumnUtils';
import { APICore } from '../../../../helpers/api/apiCore';

const api = new APICore();
const AddZone = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showEditZoneModal, setShowEditZoneModal] = useState(false);
    const [editZoneData, setEditZoneData] = useState(null);
    const [showDeleteZoneModal, setShowDeleteZoneModal] = useState(false);
    const [zoneToDelete, setZoneToDelete] = useState(null);
    const [data, setData] = useState([]);
    const [vendor, setVendor] = useState([]);

    useEffect(() => {
        getAllVendorsData();
        getAllZoneData(limit, pageNumber);
    }, []);

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    let userId = auth && auth.user && auth.user._id && auth.user._id;

    const getAllVendorsData = async () => {
        try {
            Loading();

            let response = await getAllVendorsAPI();

            if (response && response?.length > 0) {
                setVendor(response);
            }
        } catch (error) {
            console.error('Error vendor data:', error);
            toast.error(t('Failed to refresh vendor data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const getAllZoneData = async (limits, pages) => {
        try {
            Loading();

            let limitNumber = limits || limit;
            let pagesNumber = pages || pageNumber;

            let request = {
                limit: limitNumber,
                page: pagesNumber,
            };

            let response = await getAllZonesPageAPI(request);
            console.log('ZONE API RAW RESPONSE:', response);

            if (response && response.data && response.data.length > 0) {
                let dataArray = response.data.map((item) => {
                    return {
                        id: item.id,
                        createdDate: moment(item.createdAt).format('Do MMM YYYY, h:mm A'),

                        zoneName: item.zone_name,
                        zoneCode: item.zone_code,
                        zoneId: item.zone_id,

                        status: item.status,

                        action: (
                            <div className="d-flex justify-content-center align-items-center gap-1">
                                <Link to="#" className="action-icon" onClick={() => openEditZoneModal(item)}>
                                    <i className="mdi mdi-pencil"></i>
                                </Link>

                                <Link
                                    to="#"
                                    className="action-icon text-danger"
                                    onClick={() => openDeleteZoneModal(item.id)}>
                                    <i className="mdi mdi-delete"></i>
                                </Link>
                            </div>
                        ),
                    };
                });

                setPageNumber(response.currentPage || 1);
                setPageCount(response.totalPages || 1);
                setTotalCount(response.totalCount || response.data.length);

                setData(dataArray);

                new bootstrap.Modal(document.getElementById('updateZone')).show();
            } else {
                toast.error('No zone data found', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching zone data:', error);
            toast.error('Failed to refresh zone data', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAllZoneData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAllZoneData(limit, value);
    };

    const closeModalWithHeaderClass = () => {
        setShowModal(false);
        reset();
    };
    const openModalWithHeaderClass = () => {
        setShowModal(true);
    };

    const closeEditZoneModal = () => {
        setShowEditZoneModal(false);
        resetEditZone();
    };
    const openEditZoneModal = (data) => {
        setEditZoneData(data);
        setShowEditZoneModal(true);
    };

    const openDeleteZoneModal = (id) => {
        setZoneToDelete(id);
        setShowDeleteZoneModal(true);
    };

    const closeDeleteZoneModal = () => {
        setShowDeleteZoneModal(false);
        setZoneToDelete(null);
    };

    const zoneSchemaResolver = yupResolver(
        yup.object().shape({
            zone_name: yup.string().required('Zone name is required'),
            zone_code: yup.string().required('Zone code is required'),
            zone_id: yup.string().required('Zone ID is required'),
            status: yup.string().required('Please select status'),
        })
    );

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: zoneSchemaResolver,
    });

    const {
        register: registerEditZone,
        handleSubmit: handleSubmitEditZone,
        formState: { errors: errorsEditZone },
        reset: resetEditZone,
        setValue: setValueEditZone,
    } = useForm({
        resolver: zoneSchemaResolver,
    });

    useEffect(() => {
        if (showEditZoneModal && editZoneData) {
            setValueEditZone('zone_name', editZoneData.zone_name || '');
            setValueEditZone('zone_code', editZoneData.zone_code || '');
            setValueEditZone('zone_id', editZoneData.zone_id || '');
            setValueEditZone('status', editZoneData.status || '');
        }
    }, [showEditZoneModal, editZoneData, setValueEditZone]);

    const onSubmitAddZone = async (formData) => {
        setLoader(true);

        try {
            const payload = { ...formData, userId };
            const response = await addZoneAPI(payload);
            // console.log('ZONE API RAW RESPONSE', response);
            if (response) {
                toast.success('Zone added successfully');
                getAllZoneData(limit, pageNumber);
                setShowModal(false);
                reset();
            } else {
                toast.error('Zone already exists');
            }
        } catch (error) {
            console.error('Add Zone Error:', error);
            toast.error('Failed to add zone');
        }

        setLoader(false);
    };

    const onEditZone = async (formData) => {
        setLoader(true);

        try {
            formData.id = editZoneData?.id;

            const response = await editZoneAPI(formData);

            if (response) {
                toast.success('Zone updated successfully');
                getAllZoneData();
                setShowEditZoneModal(false);
                resetEditZone();
            } else {
                toast.error('Failed to update zone');
            }
        } catch (error) {
            console.error('Edit Zone Error:', error);
            toast.error('Something went wrong');
        }

        setLoader(false);
    };

    const onDeleteZone = async () => {
        if (!zoneToDelete) return;

        Loading();

        try {
            const response = await deleteZoneAPI(zoneToDelete);

            if (response) {
                getAllZoneData();
                toast.success('Zone deleted successfully');
            } else {
                toast.error('Failed to delete zone');
            }
        } catch (error) {
            console.error('Delete Zone Error:', error);
            toast.error('Something went wrong');
        }

        closeDeleteZoneModal();
        Loading();
    };

    return (
        <div style={{ width: '100%' }}>
            <div className="row">
                <div className="w-100 d-flex justify-content-between">
                    <div className="col-sm-6" style={{ marginLeft: '-2rem' }}>
                        <button className="btn_1">{t('ZONE')}</button>
                    </div>

                    <div className="col-sm-6 d-flex justify-content-end">
                        <Button className="export text-black" onClick={openModalWithHeaderClass}>
                            <span className="d-flex align-items-center gap-1">
                                {t('ADD Zone')} <i className="fas fa-plus"></i>
                            </span>
                        </Button>

                        <button
                            className="update"
                            id="update"
                            type="button"
                            onClick={() => getAllZoneData(limit, pageNumber)}>
                            {t('Update')} <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={closeModalWithHeaderClass} centered size="lg">
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Add Zone')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmitAddZone)}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Name')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.zone_name ? 'is-invalid' : ''}`}
                                    placeholder="Enter Zone Name"
                                    {...register('zone_name')}
                                />
                                {errors.zone_name && <p className="text-danger">{errors.zone_name.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Code')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.zone_code ? 'is-invalid' : ''}`}
                                    placeholder="Enter Zone Code"
                                    {...register('zone_code')}
                                />
                                {errors.zone_code && <p className="text-danger">{errors.zone_code.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone ID')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.zone_id ? 'is-invalid' : ''}`}
                                    placeholder="Enter Zone ID"
                                    {...register('zone_id')}
                                />
                                {errors.zone_id && <p className="text-danger">{errors.zone_id.message}</p>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Status')}</label>
                                <select
                                    className={`form-select ${errors.status ? 'is-invalid' : ''}`}
                                    {...register('status')}>
                                    <option value="">Select Status</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                                {errors.status && <p className="text-danger">{errors.status.message}</p>}
                            </div>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" />
                                        Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={showEditZoneModal} onHide={closeEditZoneModal} centered size="lg">
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Edit Zone')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmitEditZone(onEditZone)}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Name')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEditZone.zone_name ? 'is-invalid' : ''}`}
                                    {...registerEditZone('zone_name')}
                                />
                                {errorsEditZone.zone_name && (
                                    <p className="text-danger">{errorsEditZone.zone_name.message}</p>
                                )}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone Code')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEditZone.zone_code ? 'is-invalid' : ''}`}
                                    {...registerEditZone('zone_code')}
                                />
                                {errorsEditZone.zone_code && (
                                    <p className="text-danger">{errorsEditZone.zone_code.message}</p>
                                )}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Zone ID')}</label>
                                <input
                                    type="text"
                                    className={`form-control ${errorsEditZone.zone_id ? 'is-invalid' : ''}`}
                                    {...registerEditZone('zone_id')}
                                />
                                {errorsEditZone.zone_id && (
                                    <p className="text-danger">{errorsEditZone.zone_id.message}</p>
                                )}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Status')}</label>
                                <select
                                    className={`form-select ${errorsEditZone.status ? 'is-invalid' : ''}`}
                                    {...registerEditZone('status')}>
                                    <option value="">Select Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                                {errorsEditZone.status && (
                                    <p className="text-danger">{errorsEditZone.status.message}</p>
                                )}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t('Updated Date')}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={moment(editZoneData?.updatedAt).format('Do MMM YYYY, h:mm A')}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" />
                                        Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <div className="modal fade" id="updateZone" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button type="button" className="btn-close ms-auto" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('Zone data refreshed successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showDeleteZoneModal} onHide={closeDeleteZoneModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Delete Zone')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Delete"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />

                    <p className="mt-3">{t('Are you sure you want to delete this zone')}?</p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            variant="secondary"
                            onClick={closeDeleteZoneModal}
                            style={{ width: '100px', borderRadius: '0' }}>
                            No
                        </Button>

                        <Button
                            variant="outline-danger"
                            onClick={onDeleteZone}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                                border: '2px solid red',
                            }}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <div
                className="col-6 col-sm-6 card-add-station p-3 border-0 text-start no-radius my-2"
                style={{
                    width: '100%',
                    boxShadow: '0px 0px 35px rgba(154, 161, 171, 0.15)',
                }}>
                <div className="station-table-wrapper">
                    <Table
                        columns={addZoneColumns(t)}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddZone;
